import styles from './style.module.scss';

export const PAGE_TITLE_BAR_HEIGHT = 48;

export interface PageTitleBarProps {
  pageTitle?: string;
}

const PageTitleBar = ({ pageTitle = '' }: PageTitleBarProps) => {
  return (
    <div className={styles.pageTitleBar}>
      <div className={styles.center}>
        <div className={styles.title}>{pageTitle}</div>
      </div>
    </div>
  );
};

export default PageTitleBar;
